<div
  *ngFor="let header of headers; let i = index"
  [class.selected]="i === currentStep"
  (click)="jumpStep.emit(i)"
  [ngStyle]="{ width: calcWidth(i) }"
>
  STEP {{ i + 1 }} - {{ header }}
</div>
